import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Constants } from '../shared/constants';
import { HeaderFilterOption, LoadOptions } from '../shared/models/shared.model';
import { Observable } from 'rxjs';
import { SalonTypeResultModel } from '../shared/models/salon-type.model';
import { HeaderFilterData } from '../shared/models/product.model';

@Injectable({
	providedIn: 'root'
})
export class SalonTypeService {
	private token = localStorage.getItem('token');
	private headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + this.token });

	private url = Constants.devServerEndpoint + 'api/salontypemapping';

	constructor(private httpClient: HttpClient) { }

	public getSalonTypeMappingData(param: LoadOptions): Observable<SalonTypeResultModel> {
		return this.httpClient
			.post<SalonTypeResultModel>(
				this.url + `/getSalonTypeMappingData/`, param,
				{ headers: this.headers }
			);
	}

	public getHeaderFiltersSalonTypeMapping(param: HeaderFilterOption): Observable<HeaderFilterData[]> {
		return this.httpClient
			.post<HeaderFilterData[]>(
			this.url + `/getHeaderFiltersSalonTypeMapping`, param,
			{ headers: this.headers }
			);
	}

	public mappingAction(param): Observable<any> {
		return this.httpClient
			.post<any>(
			this.url + '/mappingAction', param,
			{ headers: this.headers }
			);
	}
}
